import { stringToId } from "./srtringToId.js";
const createFormFieldId = ({ id, label, trailing = '' })=>id ?? `${stringToId(label)}${trailing ? `-${trailing}` : ''}`;
export { createFormFieldId };
